import * as React from 'react';
import { useMemo } from 'react';

import Box from '@mui/material/Box';

import {
  CheckBox,
  DataGridPremium,
  GridColDef,
  styled,
} from '@sbv-clients/ui-shared';
import { nameOfFactory } from '@sbv-clients/util-misc';

import { FacilityMenuByIdResponseType } from '../../services/admin';
import { ParentMenuWithSubMenuItemsType } from '../../utils/transform';
import { MenuPermissionsActionType } from './use-menu-permissions';

const menuKeys = nameOfFactory<ParentMenuWithSubMenuItemsType>();

interface DetailsTableProps {
  data: ParentMenuWithSubMenuItemsType;
  allowedItemsMap: Record<string, boolean>;
  actions: MenuPermissionsActionType;
}

const DetailsTable = ({
  data,
  actions,
  allowedItemsMap,
}: DetailsTableProps) => {
  const columns = useMemo(() => {
    return [
      {
        field: menuKeys('order'),
        headerName: 'Order',
        width: 100,
        sortable: false,
      },
      {
        field: menuKeys('label'),
        headerName: 'Label',
        width: 200,
        sortable: false,
      },
      { field: menuKeys('link'), headerName: 'Link', flex: 1, sortable: false },
      {
        field: 'actions',
        headerName: 'Enabled',
        width: 300,
        sortable: false,
        filterable: false,
        renderCell: (params) => {
          const id = params?.row?.id as string;
          const checked = allowedItemsMap[id] ?? false;
          return (
            <Box>
              <CheckBox
                size="small"
                name={id}
                checked={checked}
                onChange={actions.onChangeParentMenuItem}
              />
            </Box>
          );
        },
      },
    ] as GridColDef<FacilityMenuByIdResponseType>[];
  }, [actions.onChangeParentMenuItem, allowedItemsMap]);

  return (
    <DataGridPremium
      rows={data.children}
      columns={columns}
      disableColumnMenu
      hideFooter
    />
  );
};

export default DetailsTable;
